import {FraisMissionRegion} from "@domain/od/engagements/indemnites/frais-mission-region";
import {ListItem} from "@domain/common/list-view/list-item";

/**
 * Modèle détail d'un frais de mission (admin)
 * Représente les informations communes à un groupe de FraisMission
 */
export class FraisMissionDetail {
    /** Identifiant du taux */
    idTaux: number;
    /** Région/Territoire associé */
    fraisMissionRegion: FraisMissionRegion;
    /** Période minimum en jours */
    periodeMin: number;
    /** Période maximum en jours */
    periodeMax: number;
    /** Indicateur taux spécial */
    hasTauxSpecial: boolean;
    /** Libellé du taux spécial */
    libelleSpecial: string;
    /** Code devise */
    devise: string;

    /**
     * Constructeur
     */
    constructor(data?: Partial<FraisMissionDetail>) {
        Object.assign(this, data);
        this.periodeMin = this.periodeMin ?? 1;
        this.devise = this.devise ?? 'EUR';
        //Déterminer si c'est un taux spécial
        this.hasTauxSpecial = !!this.libelleSpecial;
        //Mapping libelle → libelleTerritoire pour la région
        if ((this.fraisMissionRegion as any)?.libelle && !this.fraisMissionRegion.libelleTerritoire) {
            this.fraisMissionRegion.libelleTerritoire = (this.fraisMissionRegion as any).libelle;
        }
    }
}

/**
 * Représente une date d'application
 */
export class DateApplication implements ListItem {
    /** Identifiant du FraisMission en base */
    idTaux: number;
    /** Date d'application */
    dateApplication: Date;
    /** Montant  */
    montant: number;
    /** Devise */
    devise: string;
    /** Période min */
    periodeMin: number;
    /** Période max */
    periodeMax: number;
    /** Libellé spécial */
    libelleSpecial: string;
    /** Région */
    fraisMissionRegion: FraisMissionRegion;
    /** Liste des indemnités par domaine */
    listeFraisMissionIndemnite: IndemniteDetail[];
    /** Indique si la date d'application est déjà utilisée dans une IJ */
    dateUtilisee: boolean;

    /**
     * Constructeur
     */
    constructor(data?: any) {
        Object.assign(this, data);
        //Conversion de la date string en objet Date
        if (typeof this.dateApplication === 'string') {
            this.dateApplication = new Date(this.dateApplication);
        }
        //Instanciation des indemnités
        this.listeFraisMissionIndemnite = (data?.listeFraisMissionIndemnite ?? [])
            .map(i => new IndemniteDetail(i));
        //Mapping libelle → libelleTerritoire pour la région
        if ((this.fraisMissionRegion as any)?.libelle && !this.fraisMissionRegion.libelleTerritoire) {
            this.fraisMissionRegion.libelleTerritoire = (this.fraisMissionRegion as any).libelle;
        }
    }

    /**
     * Retourne la clé unique de l'item
     */
    getKey(): number {
        return this.idTaux;
    }
}

/**
 * Détail d'une indemnité par domaine
 */
export class IndemniteDetail {
    /** Identifiant du domaine */
    idDomaine: number;
    /** Libellé du domaine */
    libelleDomaine: string;
    /** Pourcentage */
    pourcentage: number;
    /** Montant */
    montant: number;

    /**
     * Constructeur
     */
    constructor(data?: Partial<IndemniteDetail>) {
        Object.assign(this, data);
    }
}